
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/info",
      function () {
        return require("private-next-pages/stores/[cName]/info.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/info"])
      });
    }
  